'use client';

import { Typography } from '@musinsa/mds';
import { Tooltip } from '@musinsa/mds-ui';
import type { MyCurationItem } from '@musinsa/services-curator';
import { useState } from 'react';
import { CurationTitleSectionIcMoreBottomSheet } from '../../shop/components/CurationTitleSectionIcMoreBottomSheet';

interface TitleSectionItem {
  title: string;
  description?: string | null;
}

interface Props {
  item: TitleSectionItem;
  curationIndex?: number;
  useMoreButton?: boolean;
}

export const TitleSection = ({ item, curationIndex, useMoreButton = false }: Props) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="relative flex px-4 pt-6 pb-3 justify-between items-end">
      <div className="flex flex-col gap-1">
        <Typography variant="title18pxMed">{item.title}</Typography>
        {item.description && (
          <Typography variant="body13pxReg" colorScheme="gray-600">
            {item.description}
          </Typography>
        )}
      </div>
      {/* NOTE: My 큐레이션 샵에만 툴팁 노출. 최초 첫번째 큐레이션에 1회만 노출 */}
      {curationIndex === 0 && (
        <Tooltip
          className="!absolute right-[12px] -bottom-40 z-100 whitespace-nowrap"
          align="bottom right"
          content={
            <>
              큐레이션의 편집 및 바로가기 링크를
              <br />
              복사할 수 있습니다.
            </>
          }
          duration={5000}
          storageKey="tooltip-curation-title-button"
          maxCount={1}
        />
      )}

      {useMoreButton && 'snapItems' in item && (
        <CurationTitleSectionIcMoreBottomSheet
          item={item as MyCurationItem}
          curationIndex={curationIndex ?? 0}
          open={open}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
        />
      )}
    </div>
  );
};
